/**
 * Created by Angelika on 30.08.2017.
 */
import React, {Component} from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import * as def from '../constants/defines';

import './ChannelItem.css';
import EmbedVideoComponent from "./EmbedVideo";
import {channel_preview_logo_url} from "../config";

class ChannelItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            busy: false,
            emptyPreviewImage: false,
            active: false
        };

        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
        this.getChannelPreviewLogo = this.getChannelPreviewLogo.bind(this);
        this.handleImageLoadError = this.handleImageLoadError.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.item.channelID !== this.props.item.channelID ||
            nextProps.item.favorite !== this.props.item.favorite) {
            this.setState({busy: false, emptyPreviewImage: false});
        }
    }

    onFavoriteClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.state.busy) {
            const {item, favoritesActions} = this.props;
            const {addFavorite, deleteFavorite} = favoritesActions;
            this.setState({busy: true}, () =>
                setTimeout(() => {
                    if (item.favorite === 1) {
                        deleteFavorite(item)
                    } else {
                        addFavorite(item)
                    }
                }, def.FAVORITE_CHANGE_TIMEOUT)
            );
        }
    }

    handleMouseOver() {

        if (this.timer) {
            clearTimeout(this.timer);
        }

        if (this.state.active) {
            return false;
        }

        this.timer = setTimeout(() => {
            this.setState({active: true})
        }, 1000)
    }

    handleMouseOut() {

        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.setState({active: false})
    }

    actionStopVideo() {
        const {channelsActions, videoActions} = this.props;
        channelsActions.resetChannelActive();
        videoActions.resetVideo();
    }

    favoriteClasses(item) {
        let classes = ['favorite-mark'];
        if (this.state.busy) {
            classes.push('loader');
        }
        if (item.favorite === 1) {
            classes.push('marked');
        }
        return classes.join(' ');
    }

    getChannelPreviewLogo() {
        return channel_preview_logo_url + this.props.item.channelID + '.png';
    }

    handleImageLoadError(event) {
        this.setState({emptyPreviewImage: true});
    }

    render() {
        const {item, onClick} = this.props;
        const {active, emptyPreviewImage} = this.state;

        return (
            <Link to={`/channels/${item.channelID}`} onClick={onClick}
                  className={"channel-list-item-component" + (active ? ' active' : '')}>
                <div className="channel-list-item" onMouseEnter={this.handleMouseOver}
                     onMouseLeave={this.handleMouseOut}>
                    <div className="channel-list-item-wrapper">
                        <div className="channel-preview">
                            <div className={this.favoriteClasses(item)} onClick={e => this.onFavoriteClick(e)}></div>
                            {active ?
                                <EmbedVideoComponent channel={item}></EmbedVideoComponent>
                                :
                                <div className="channel-preview-description-container">

                                    {emptyPreviewImage ?
                                    <div className="channel-name">
                                        {item.name}
                                    </div>
                                        :
                                        <LazyLoad overflow={true} height={268}>
                                            <img className="lazy" src={this.getChannelPreviewLogo()} onError={(event) => this.handleImageLoadError(event)} alt=""/>
                                        </LazyLoad>
                                    }
                                </div>
                            }
                        </div>
                        <div className="channel-details">
                            {item.image &&
                            <div className="channel-logo">
                                <LazyLoad overflow={true} height={268} once>
                                    <img src={item.image} alt=""/>
                                </LazyLoad>
                            </div>}
                            <div className="channel-name">
                                {item.name}
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        )
    }
}

ChannelItem.propTypes = {
    item: PropTypes.shape({
        channelID: PropTypes.number.isRequired,
        image: PropTypes.string,
        name: PropTypes.string.isRequired
    }).isRequired,
    onClick: PropTypes.func.isRequired
};

export default ChannelItem;



// WEBPACK FOOTER //
// ./src/components/ChannelItem.js